import { Checkbox, FormControl, FormControlLabel, FormHelperText, Typography } from '@material-ui/core';
import React from 'react';
import GoogleTagManager from '../../../gtm/GoogleTagManager';
import GtmFormularfeldId, { createGtmFieldId } from '../../../gtm/types/GtmFormularfeldId';
import muiFormControlLabelCss from '../../../assets/css/mui.checkbox.form-control-label.module.css';
import muiCheckboxCss from '../../../assets/css/mui.checkbox.module.css';
import InputEvents from './InputEvents';

type Param = {
    onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    preventSubmitOnEnter?: boolean | true,
    value?: boolean,
    label?: string,
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number
    required?: boolean,
    error?: boolean,
    helperText?: string,
    variant?: 'body1' | 'caption',
}

const CheckboxField: React.FC<Param> = ({ onBlur, onChange, preventSubmitOnEnter = true, value, label, id, idGtm, idGtmIndex, required, error, helperText, variant = 'body1' }) => {

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    const onKeyPressEnter = (event: any) => {
        if (preventSubmitOnEnter === true) {
            InputEvents.preventOnKeyPressEnter(event);
        }
    }

    const checkBox = <Checkbox id={id}
        onFocus={handleOnFocus}
        onBlur={onBlur}
        onChange={onChange}
        onKeyPress={onKeyPressEnter}
        checked={value}
        required={required}
        classes={muiCheckboxCss}
        color='default'
    />


    return (
        <FormControl error={error}>
            <FormControlLabel classes={muiFormControlLabelCss} style={{ transition: 'all 1s ease-in-out' }}
                control={checkBox}
                label={<Typography variant={variant}>{label}</Typography>}
            />
            <div style={{ height: 'auto' }}>
                <FormHelperText>{helperText}</FormHelperText>
            </div>
        </FormControl >
    );
}

export default CheckboxField;